<template>
  <div class="device-detail-status">
    <device-component-list ref="list" :bodyNum="bodyNum"></device-component-list>
  </div>
</template>

<script>
import deviceComponentList from '@/components/deviceComponentList';

export default {
  props: {
    deviceInfo: Object
  },
  computed: {
    bodyNum() {
      return this.deviceInfo ? this.deviceInfo.bodyNum : '';
    }
  },
  components: {
    deviceComponentList
  },
  data() {
    return {
    };
  },
  methods: {
    udpate() {
      this.$refs.list.getList();
    }
  }
};
</script>

<style lang="scss">
.device-detail-status {
  padding: 0 24px 44px 24px;
}
</style>
